module.exports = __webpack_public_path__ + "img/error404.8370b6ee.png";